import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function LatestArticles() {
  const latestArticles = getLatestArticles(4);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              最新<span className="text-primary-500">资讯</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-600">深度影评与大片推荐</p>
          </div>
          <Link to="/category/sci-fi" className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap">
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="text-sm md:text-base font-bold font-heading text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed">{article.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
        <div className="mt-8 text-center sm:hidden">
          <Link to="/category/sci-fi" className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 cursor-pointer">
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}